import ko from 'knockout';

// Workaround indicator for jqInputmask bug, which occures when you use
// observable.computedView('view') on value binding
// and element value ain't updates after computedView modificates observable value.
ko.bindingHandlers.jqInputmaskForceUpdateFromModel = {

	after: ["value"],

	init: function (element, valueAccessor, allBindings) {
		if (!allBindings['has']('value')){
			//eslint-disable-next-line max-len
			throw new Error("jqInputmaskForceUpdateFromModel is redundant. No value binding defined");
		}
	},
};